import Box from "@cloudscape-design/components/box";
import Spinner from "@cloudscape-design/components/spinner";
import { useEffect } from "react";
import { api } from "../../api/client";
import { normalizeReferralCode, writeReferralCookie } from "../../lib/referral";
import { navigate } from "../../router/useRoute";

/**
 * Điểm đến của link đối tác: `facego.site/r/<mã>`.
 *
 * Ba việc, đúng thứ tự đó: cất mã vào cookie 30 ngày, báo về máy chủ một lượt
 * bấm, rồi đưa khách sang trang đăng ký. Cất cookie **trước** khi gọi mạng vì
 * việc ghi công đối tác không được phụ thuộc vào một request có thể hỏng.
 *
 * Đây cũng là chỗ duy nhất đếm được lượt bấm. `?ref=` gắn vào một trang bất kỳ
 * vẫn ăn cookie như cũ, nhưng không đi qua đây thì không có gì để đếm.
 */
export function ReferralLandingPage() {
  useEffect(() => {
    const raw = window.location.pathname.replace(/\/+$/, "").split("/r/")[1] || "";
    const code = normalizeReferralCode(decodeURIComponent(raw));
    if (code) {
      writeReferralCookie(code);
      void api("/affiliate/click", { method: "POST", body: { code, channel: "web" } }).catch(() => undefined);
    }
    // `replace` để nút Back của khách quay về nơi họ đến, không quay lại đây rồi
    // chuyển tiếp lần nữa.
    navigate("/register", { replace: true });
  }, []);

  return (
    <Box margin={{ top: "xxxl" }} textAlign="center">
      <Spinner size="large" />
      <Box variant="p" padding={{ top: "s" }} color="text-body-secondary">
        Đang mở FaceGo và áp ưu đãi từ người giới thiệu…
      </Box>
    </Box>
  );
}
